import { text, brandText } from '@guardian/src-foundations/palette';

export const labelDefault = {
	label: {
		textLabel: text.inputLabel,
		textOptional: text.supporting,
		textSupporting: text.supporting,
		textError: text.error,
		textSuccess: text.success,
	},
};

export const labelBrand = {
	label: {
		textLabel: brandText.inputLabel,
		textOptional: brandText.supporting,
		textSupporting: brandText.supporting,
		textError: brandText.error,
		textSuccess: brandText.success,
	},
};
